const formatFormData = (item) => {
  return {
    resumeId: item?.resumeId || "",
    resumeTitle: item?.resumeTitle || "Untitled",
    eduFlag: item?.eduFlag ?? true,
    workFlag: item?.workFlag ?? true,
    achFlag: item?.achFlag ?? true,
    addFlag: item?.addFlag ?? true,
    skillFlag: item?.skillsFlag ?? true,
    proFlag: item?.proFlag ?? true,
    Details: item?.personalDetails
      ? [
          {
            fullName: item?.personalDetails?.fullName || "",
            email: item?.personalDetails?.email || "",
            phone: item?.personalDetails?.phone || "",
            address: item?.personalDetails?.address || "",
            website: item?.personalDetails?.website || "",
            linkedin: item?.personalDetails?.linkedin || "",
            github: item?.personalDetails?.github || "",
            about: item?.personalDetails?.summary || "",
          },
        ]
      : [],
    education: item?.education || [],
    experience:
      item?.experience?.map((exp) => ({
        jobRole: exp?.jobRole || "",
        companyName: exp?.companyName || "",
        companyLocation: exp?.companyLocation || "",
        fromDate: exp?.fromDate || "",
        toDate: exp?.toDate || "",
        jobDescription: exp?.responsibilities,
      })) || [],
    skills:
      item?.skills?.map((skill) => ({
        title: skill?.title || "",
        skillList: skill?.skillList?.join(", ") || "",
      })) || [],
    achivawards:
      item?.achivawards?.map((achi) => ({
        achivawards: achi || "",
      })) || [],
    additionalInfo:
      item?.additionalInfo?.map((info) => ({
        addInfo: info?.addInfo || "",
      })) || [],
    projects:
      item?.projects?.map((proj) => ({
        title: proj?.title || "",
        stack: proj?.stack?.join(", ") || "",
        desc: proj?.desc ? proj?.desc.toString() : "",
      })) || [],
    profileImage: "",
    templateKey: item?.templateKey,
  };
};

export default formatFormData;
